import { render, staticRenderFns } from "./CustomSectionScroll.vue?vue&type=template&id=f37690f4&scoped=true&"
import script from "./CustomSectionScroll.vue?vue&type=script&lang=js&"
export * from "./CustomSectionScroll.vue?vue&type=script&lang=js&"
import style0 from "./CustomSectionScroll.vue?vue&type=style&index=0&id=f37690f4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37690f4",
  null
  
)

export default component.exports